import { z } from "zod";

export const BookmarkContextKeySchema = z.enum(["tasks", "contacts"]);
export type BookmarkContextKey = z.infer<typeof BookmarkContextKeySchema>;

export const DueDateFilterSchema = z.enum([
  "past_due",
  "today",
  "tomorrow",
  "this_week",
  "next_week",
  "no_date",
]);
export type DueDateFilter = z.infer<typeof DueDateFilterSchema>;

export const TasksBookmarkParamsSchema = z.object({
  tag: z.string().optional(),
  assignee: z.uuid().optional(),
  contact: z.uuid().optional(),
  due_date: DueDateFilterSchema.optional(),
  show_completed: z.literal("1").optional(),
});

export const ContactsBookmarkParamsSchema = z.object({
  tag: z.string().optional(),
});

export const BookmarkParamsSchema = z.union([
  TasksBookmarkParamsSchema,
  ContactsBookmarkParamsSchema,
]);
export type BookmarkParams = z.infer<typeof BookmarkParamsSchema>;

const BookmarkBaseSchema = z.object({
  id: z.uuid(),
  organizationId: z.uuid(),
  creatorId: z.uuid(),
  name: z.string(),
  private: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date().nullable(),
  removedAt: z.date().nullable(),
});

export const BookmarkSchema = z.discriminatedUnion("contextKey", [
  z.object({
    ...BookmarkBaseSchema.shape,
    contextKey: z.literal("tasks"),
    params: TasksBookmarkParamsSchema,
  }),
  z.object({
    ...BookmarkBaseSchema.shape,
    contextKey: z.literal("contacts"),
    params: ContactsBookmarkParamsSchema,
  }),
]);

export const CreateBookmarkSchema = z.discriminatedUnion("contextKey", [
  z.object({
    contextKey: z.literal("tasks"),
    name: z.string().min(1).max(100),
    params: TasksBookmarkParamsSchema,
    private: z.boolean().default(true),
  }),
  z.object({
    contextKey: z.literal("contacts"),
    name: z.string().min(1).max(100),
    params: ContactsBookmarkParamsSchema,
    private: z.boolean().default(true),
  }),
]);

export const UpdateBookmarkSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  private: z.boolean().optional(),
});

export type Bookmark = z.infer<typeof BookmarkSchema>;
export type CreateBookmark = z.infer<typeof CreateBookmarkSchema>;
export type UpdateBookmark = z.infer<typeof UpdateBookmarkSchema>;
